import(/* webpackMode: "eager" */ "/vercel/path0/src/app/coop/page.tsx");
